function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4_49)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 1.44C8.81438 1.44 6.24 4.01438 6.24 7.2V9.6H4.32C3.53063 9.6 2.88 10.2506 2.88 11.04V22.56C2.88 23.3494 3.53063 24 4.32 24H19.68C20.4694 24 21.12 23.3494 21.12 22.56V11.04C21.12 10.2506 20.4694 9.6 19.68 9.6H17.76V7.2C17.76 4.01438 15.1856 1.44 12 1.44ZM12 2.4C14.6719 2.4 16.8 4.52813 16.8 7.2V9.6H7.2V7.2C7.2 4.52813 9.32813 2.4 12 2.4ZM4.32 10.56H19.68C19.9463 10.56 20.16 10.7738 20.16 11.04V22.56C20.16 22.8263 19.9463 23.04 19.68 23.04H4.32C4.05376 23.04 3.84 22.8263 3.84 22.56V11.04C3.84 10.7738 4.05376 10.56 4.32 10.56ZM12 14.4C11.1844 14.4 10.56 15.0244 10.56 15.84C10.56 16.2713 10.7513 16.65 11.04 16.89V18.24C11.04 18.7688 11.4713 19.2 12 19.2C12.5288 19.2 12.96 18.7688 12.96 18.24V16.89C13.2488 16.65 13.44 16.2713 13.44 15.84C13.44 15.0244 12.8156 14.4 12 14.4Z",
  fill: "#444A52",
  stroke: "#444A52",
  strokeWidth: 0.2
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4_49"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgLockUser = function SvgLockUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-user.82a4be3c.svg";
export { ForwardRef as ReactComponent };